import React, { useEffect, useState } from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const purchases = [['Olivia K.', 'New York, USA', 'Rugby Ready'], ['James M.', 'London, UK', 'Rugby Ready Complete Box Set'], ['Priya T.', 'Auckland, NZ', 'Rugby Ready'], ['David R.', 'Melbourne, Australia', 'Rugby Ready Complete Box Set']];
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [purchase, setPurchase] = useState(purchases[0]);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let cycleTimer: number;
    const show = () => {
      setPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        cycleTimer = window.setTimeout(show, 28000 + Math.floor(Math.random() * 14000));
      }, 5000);
    };
    const initialTimer = window.setTimeout(show, 15000);
    return () => {
      window.clearTimeout(initialTimer);
      window.clearTimeout(hideTimer);
      window.clearTimeout(cycleTimer);
    };
  }, [dismissed]);
  if (dismissed) return null;
  return <aside aria-live="polite" className={`fixed bottom-4 left-4 z-50 w-[calc(100%-2rem)] max-w-sm transition-all duration-500 ${visible ? 'translate-x-0 opacity-100' : '-translate-x-[120%] opacity-0'}`} data-id="element-192">
      <div className="relative border border-[#E5E5EA] bg-white p-4 pr-10 shadow-2xl" data-id="element-193">
        <button type="button" aria-label="Dismiss recent purchase notification" onClick={() => setDismissed(true)} className="absolute right-2 top-2 p-1 text-[#5A5A66] hover:text-[#0A0A0A]" data-id="element-194">
          <XIcon className="h-4 w-4" data-id="element-195" />
        </button>
        <p className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest text-[#9b7914]" data-id="element-196">
          <span className="grid h-4 w-4 place-items-center rounded-full bg-[#d4af37]" data-id="element-197">
            <CheckIcon className="h-3 w-3 text-[#0A0A0A]" data-id="element-198" />
          </span>
          Verified purchase
        </p>
        <p className="mt-3 text-sm font-semibold text-[#0A0A0A]" data-id="element-199">
          <strong data-id="element-200">{purchase[0]}</strong> from {purchase[1]}
        </p>
        <p className="mt-1 text-xs font-medium text-[#5A5A66]" data-id="element-201">
          just purchased{' '}
          <span className="font-bold text-[#9b7914]" data-id="element-202">{purchase[2]}</span>
        </p>
      </div>
    </aside>;
}